import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from "primeng/dynamicdialog";
import { DistrictAdministrationService } from "../../services/districtadministration.service";
import { ChangeSchoolRequestModel } from "../shared/ChangeSchoolRequestModel";
import { FacilityAssignComponent } from "../shared/facility-assign/facility-assign.component";
import { AddSchoolRequest } from "../shared/AddSchoolRequest";
import { DistrictAddSchoolConfirmIDComponent } from "./district-add-school-confirm-id/district-add-school-confirm-id.component";

@Component({
	selector: "app-district-add-school",
	templateUrl: "./district-add-school.component.html",
	styleUrls: ["./district-add-school.component.css"],
})
export class DistrictAddSchoolComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private districtadministrationService: DistrictAdministrationService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.loadSchoolType();
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////
	SchoolID: number;
	SchoolNumber: string = "";
	SchoolName: string = "";
	SchoolTypeID: number;
	FacilityCD: string = "";
	FacilityName: string = "";
	Street1: string = "";
	City: string = "";
	State: string = "";
	Zip: string = "";
	WorkPhone: string = "";

	lstSchoolType: any = [];

	errorMessage: string = "";

	LoadingSchoolType: boolean = false;
	Processing: boolean = false;

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////

	loadSchoolType() {
		this.LoadingSchoolType = true;

		var result = this.districtadministrationService.LoadSchoolTypes();
		result.subscribe(
			(response) => {
				this.lstSchoolType = response;

				this.SchoolTypeID = this.lstSchoolType[0].SchoolTypeID;

				this.LoadingSchoolType = false;
			},
			(error) => {
				this.LoadingSchoolType = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.SchoolID == undefined || this.SchoolID <= 0) {
			this.errorMessage = "Enter a School ID (CANNOT BE CHANGED LATER ON, please double-check with Development)";
			return;
		} else if (this.SchoolNumber == undefined || this.SchoolNumber == "") {
			this.errorMessage = "Enter School Number (This can be changed later on)";
			return;
		} else if (this.SchoolName == undefined || this.SchoolName == "") {
			this.errorMessage = "Enter School Name (This can be changed later on)";
			return;
		} else if (this.SchoolTypeID == undefined) {
			this.errorMessage = "Select a School Type (This can be changed later on)";
			return;
		} else if (this.FacilityCD == undefined || this.FacilityCD == "") {
			this.errorMessage = "Enter Main Facility Code/Abbreviation (This can be changed later on)";
			return;
		} else if (this.FacilityName == undefined || this.FacilityName == "") {
			this.errorMessage = "Enter Main Facility Name (This can be changed later on)";
			return;
		}

		if (this.State == undefined || this.State == "") {
			this.BlankAddressConfirm();
		} else {
			this.FirstConfirm();
		}
	}

	BlankAddressConfirm() {
		this.confirmationService.confirm({
			key: "addschooladdress",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to skip adding an address? It is recommended that you at least enter a state but you can always update it later.",
			header: "Confirm Address",
			icon: "fa",
			accept: () => {
				this.FirstConfirm();
			},
		});
	}

	FirstConfirm() {
		this.confirmationService.confirm({
			key: "addschool1",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"You are about to add a school in CAASS. This can mess up the Database if the information is incorrect. Are you sure you want to continue?",
			header: "Confirm Create School",
			icon: "fa",
			accept: () => {
				this.SecondConfirm();
			},
		});
	}

	SecondConfirm() {
		this.confirmationService.confirm({
			key: "addschool2",
			acceptLabel: "Yes I have double-checked the information",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Have you DOUBLE-CHECKED the information with DEVELOPMENT and the CUSTOMER CARE team? Incorrect Information can mess up the Database.",
			header: "Confirm Information",
			icon: "fa",
			accept: () => {
				this.ThirdConfirm();
			},
		});
	}

	ThirdConfirm() {
		var ref = this.dialogService.open(DistrictAddSchoolConfirmIDComponent, {
			header: "Add",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response.Success == true) {
				this.FinishAddSchool();
			} else {
				if (response.Error == true) {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addschool3",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School IDs don't match. Please double check all of the information.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			}
		});
	}

	FinishAddSchool() {
		this.Processing = true;

		var parms: AddSchoolRequest = {
			SchoolID: this.SchoolID,
			SchoolNumber: this.SchoolNumber,
			SchoolName: this.SchoolName,
			SchoolTypeID: this.SchoolTypeID,
			Street1: this.Street1,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			WorkPhone: this.WorkPhone,
			FacilityCD: this.FacilityCD,
			FacilityName: this.FacilityName,
		};

		var result = this.districtadministrationService.AddSchool(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addschoolresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School was added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addschoolresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the school: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////

	onSchoolIDChange(val) {
		this.SchoolID = val;

		// if(this.SchoolNumber == undefined || this.SchoolNumber == ""){
		this.SchoolNumber = String(this.SchoolID);
		// }
		// if(this.FacilityCD == undefined || this.FacilityCD == ""){
		this.FacilityCD = String(this.SchoolID);
		// }
	}

	onSchoolNameChange(val) {
		this.SchoolName = val;

		// if(this.FacilityName == undefined || this.FacilityName == ""){
		this.FacilityName = String(this.SchoolName);
		// }
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingSchoolType == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////
}
